import React, { useEffect, useState } from "react";
import "./Share.css";
import ShareSquare from "./ShareSquare/ShareSquare.js";
import rapperImageLoader from "../../utils/helperFunctions.js";
import QRlogo from "../../assets/images/crown-qr.png";
import cmplxLogo from "../../assets/images/complexlogo.jpg";
import rapBracketsLogo from "../../assets/images/rapbracketslogo_big.jpg";
import { QRCode } from 'react-qrcode-logo';

function Share(props) {
  
  const [shortLink, setShortLink] = useState("");
  
  let shareURL = `https://partner.complex.com/rap-brackets-share/${props.gameData[1].id}-${props.gameData[2].id}-${props.gameData[3].id}-${props.gameData[4].id}-${props.gameData[5].id}-${props.gameData[6].id}-${props.gameData[7].id}-${props.gameData[8].id}-${props.gameData[9].id}-${props.gameData[10].id}-${props.gameData[11].id}-${props.gameData[12].id}-${props.gameData[13].id}-${props.gameData[14].id}-${props.gameData[15].id}-${props.gameData[16].id}-${props.gameData[17].id}-${props.gameData[18].id}-${props.gameData[19].id}-${props.gameData[20].id}-${props.gameData[21].id}-${props.gameData[22].id}-${props.gameData[23].id}-${props.gameData[24].id}-${props.gameData[25].id}-${props.gameData[26].id}-${props.gameData[27].id}-${props.gameData[28].id}-${props.gameData[29].id}-${props.gameData[30].id}-${props.winner.id}`
  
  console.log(shareURL)
  
  useEffect(()=>{
      fetch(`https://partner.complex.com/rap-brackets/createurl/?link=${window.btoa(shareURL)}`,{
        method: 'GET',
        headers: {}
      })
      .then((response)=>{
        if(response.status !== 200){
          console.log('Shortlink api 200 Error', response.status);
          return;
        }
        response.json().then((data)=>{
          console.log(data);
          setShortLink("cmplx.it/"+data.data.short_url_part)
        });
      })
      .catch((err)=>{
        console.log('Fetch Error ', err);
      });
    },[])


  return (
    <div id="Share">
      <div className="share_left_wrap">
        <div>SHARE NOW</div>
        <div className="share_QRcode">
          <QRCode value={shareURL}
              bgColor={"#3CEE04"}
              logoImage={QRlogo}
              size={200}
              // qrStyle={"dots"}
              logoWidth={40}
              logoHeight={40}
          />
        </div>
          <div className="share_shortlink animated fadeIn">{shortLink ? shortLink : "cmplx.it"}</div>
      </div>
      <div className="share_middle_wrap">
        <div className="share_header">header</div>
        <div id="share_bracket_wrap">

            <div id="share_bracket_background">
              <div className="share_bracket_background_header"><img className="share_bracket_logo" alt="rap brackets logo" src={rapBracketsLogo} /></div>
              <div className="share_bracket_background_image"><img className="share_bracket_winner_image animated fadeIn" src={rapperImageLoader(props.winner.pic) || cmplxLogo } alt="share center img" /></div>
              <div className="share_bracket_background_footer">
                <div>MY <span className="graphikBold">RAP BRACKETS</span> WINNER IS</div>
                <div className="share_bracket_winner_name">{props.winner.name}</div>
                <div className="graphikBold">WHO IS YOURS?</div>
              </div>
            </div>

            <div id="share_bracket">
            <div className="col_one col_a">
              {}
              <div className={`bracket_square ${props.gameData[1].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[1].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[2].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[2].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[3].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[3].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[4].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[4].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[5].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[5].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[6].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[6].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[7].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[7].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[8].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[8].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_b">
              <div className={`bracket_square ${props.gameData[9].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[9].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[10].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[10].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[11].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[11].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[12].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[12].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_c">
              <div className={`bracket_square ${props.gameData[13].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[13].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[14].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[14].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_d">
              <div className={`bracket_square ${props.gameData[15].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[15].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_mid_spacer"></div>
            <div className="col_one col_e">
              <div className={`bracket_square ${props.gameData[16].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[16].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_f">
              <div className={`bracket_square ${props.gameData[17].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[17].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[18].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[18].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_g">
              <div className={`bracket_square ${props.gameData[19].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[19].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[20].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[20].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[21].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[21].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[22].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[22].pic) || cmplxLogo }/></div>
            </div>
            <div className="col_one col_h">
              <div className={`bracket_square ${props.gameData[23].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[23].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[24].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[24].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[25].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[25].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[26].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[26].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[27].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[27].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[28].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[28].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[29].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[29].pic) || cmplxLogo }/></div>
              <div className={`bracket_square ${props.gameData[30].id === props.gameData[31].id ? `winner` : ``}`}><ShareSquare shareData={rapperImageLoader(props.gameData[30].pic) || cmplxLogo }/></div>
            </div>
          </div>

        </div>
            <div className="share_bracket_shadow"></div>
        <div className="share_footer">
          <div className="share_button_restart" onClick={() => {
            props.selectGameMode("start");
            window.trackEvent('Click New Game Button');
            }}>NEW GAME</div>
        </div>
      </div>
      <div className="share_right_wrap"><img className="share_cmplx_logo" alt="complex logo" src={cmplxLogo} /></div>
    </div>
  );
}
export default Share;
